import { IonContent } from '@ionic/react';
import React from 'react';

import { STRAIGHT_MAN_CATEGORY } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { HARDCODED_CATEGORIES } from '../../../OwnAIMan/constants';

import { ScreenAboutLookStyles } from './AboutLook.styles';

export const ScreenAboutLookMale: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();

  const handleNextStep = (): void => {
    const categories = [...HARDCODED_CATEGORIES, STRAIGHT_MAN_CATEGORY];

    userService.createOrUpdate({
      categories,
      onboarding_data: {
        first_categories: categories,
      },
    });
    refreshUser();
    wizard.nextStep();
  };

  return (
    <ScreenAboutLookStyles
      bgImage={
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/bg-about-look.png"
          alt="Chat Vibe"
        />
      }
    >
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You've nailed the appearance—seriously, great choice! Now, let's dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
